import { useEffect, useState } from 'react';
import { ListItemButton, Typography, useTheme } from '@mui/material';
import { getPatients } from 'apis/admin';
import usePatient from 'store/patient/usePatient';
import MuiAutocomplete from 'components/MuiAutocomplete';
import useUser from 'store/user/useUser';
import { ReactComponent as Cookie } from 'assets/alarm-icon.svg';
import { ReactComponent as Empty } from 'assets/alarm-icon-empty.svg';
import { Dot } from 'styles/dot';
interface IOption {
  patient_id: string;
  name: string;
  age: string;
  nursing_record_exists?: number;
  other_record_exists?: number;
}

interface Props {
  user_id: number;
}

const PatientsList = ({ user_id }: Props) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const { palette } = useTheme();
  const { onSelectedPatient } = usePatient();
  const { student_uuid: isStudent } = useUser();

  useEffect(() => {
    const mode = sessionStorage.getItem('MODE');
    if (mode === 'TEST') {
      setIsDisabled(true);
    }
  }, []);

  const optionLabel = ({ patient_id, name }: IOption) =>
    `${patient_id} ${name}`;

  const Option = ({ patient_id, name, age, ...props }: IOption) => {
    const [nursingRecord, setNursingRecord] = useState([]);

    if (nursingRecord.length === 0) {
      return (
        <ListItemButton {...props} sx={{ gap: 0.5 }}>
          <Empty />
          <Typography variant="subtitle2">{patient_id}</Typography>
          <Typography
            variant="caption"
            color={palette.mode === 'dark' ? 'lightgrey' : '#000000B2'}
          >
            {name}
          </Typography>
          <Typography
            variant="caption"
            color={palette.mode === 'dark' ? 'lightgrey' : '#000000B2'}
          >
            {age}
          </Typography>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {props.nursing_record_exists === 1 && <Dot $bg="#14855B" />}
            {props.other_record_exists === 1 && <Dot $bg="#9C57C7" />}
          </div>
        </ListItemButton>
      );
    } else {
      return (
        <ListItemButton {...props} sx={{ gap: 0.5 }}>
          <Cookie />
          <Typography variant="subtitle2">{patient_id}</Typography>
          <Typography
            variant="caption"
            color={palette.mode === 'dark' ? 'lightgrey' : '#000000B2'}
          >
            {name}
          </Typography>
          <Typography
            variant="caption"
            color={palette.mode === 'dark' ? 'lightgrey' : '#000000B2'}
          >
            {age}
          </Typography>
        </ListItemButton>
      );
    }
  };

  return (
    <MuiAutocomplete
      syncWithPatient
      variant="standard"
      valueKey="patient_id"
      listKey="admin_patients"
      placeholder="patient search"
      noOptionsText="no patients found. please enter another patient name"
      getOptionLabel={optionLabel}
      renderOption={(props, option) => {
        if (!user_id) {
          return null;
        } else return <Option {...props} {...option} />;
      }}
      onChange={onSelectedPatient}
      getApi={params => getPatients({ ...params, user_id })}
      isDisabled={isDisabled}
    />
  );
};

export default PatientsList;
